import { render, staticRenderFns } from "./ErrorStat.vue?vue&type=template&id=60fc7070&scoped=true"
import script from "./ErrorStat.vue?vue&type=script&lang=ts"
export * from "./ErrorStat.vue?vue&type=script&lang=ts"
import style0 from "./ErrorStat.vue?vue&type=style&index=0&id=60fc7070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fc7070",
  null
  
)

export default component.exports